import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import Table from 'antd/lib/table';
import Button from 'antd/lib/button'
import { ResponsiveTable } from '../../../common/components/data-display';
import { Link } from 'react-router'
import { currencyFormatter,formatDateTime } from '../../utils/helpers';
import { loanStatusT } from '../../enums/index';

const Column = Table.Column;

const FraudCheckList = ({ fraudCheck, t,  startCheck, history }) => {
  const isInAdmin = window.location && window.location.href.indexOf('/admin') !== -1;



  return (
    <section className="documents-list">
      <Button onClick={startCheck} >Vykonať kontrolu</Button> { history.length > 0 && <span>Naposledy vykonaná kontrola: {formatDateTime(history[0].executedAt)}</span>  }

    {
      fraudCheck.length === 0 && history.length !== 0 && <ResponsiveTable dataSource={history} rowKey={check => check.id}>
        <Column
          title={t('Dátum kontroly')}
          key="executedAt"
          dataIndex="executedAt"
          render={(executedAt) =>  formatDateTime(executedAt)}
        />
        <Column
          title={t('Výsledok kontroly')}
          render={() => <span>Bez zhody</span>}
        />
      </ResponsiveTable>
    }

     { fraudCheck.length > 0 && <ResponsiveTable dataSource={fraudCheck} rowKey={check => check.id}>

        <Column
          title={t('Číslo pôžičky')}
          dataIndex="MatchedLoanId"
          key="MatchedLoanId"
          render={(MatchedLoanId) => <span>
            <Link to={`/admin/loans/${MatchedLoanId}`} target="_blank" rel="noopener noreferrer" >{MatchedLoanId}</Link>
          </span>}
        />
        <Column
          title={t('Meno a priezvisko dlžníka')}
          render={(_, check) => <span>{`${check.Loan.Account.nameFirst} ${check.Loan.Account.nameLast}`}</span>}
        />
        <Column
          title={t('Dátum založenia pôžičky')}
          render={(_, check) => formatDateTime(check.Loan.createdAt)}
        />
        <Column
          title={t('Výška pôžičky')}
          render={(_, check) => currencyFormatter(check.Loan.amount)}
        />
        <Column
          title={t('Stav pôžičky')}
          render={(_, check) => <span>{loanStatusT[check.Loan.status]}</span>}
        />
        <Column
          title={t('Zhodné atribúty')}
          dataIndex="matchedAttributes"
          key="matchedAttributes"
          render={(matchedAttributes) => <span>{matchedAttributes}</span>}
        />
        <Column
          title={t('Dátum kontroly')}
          dataIndex="createdAt"
          key="createdAt"
          render={(createdAt) => formatDateTime(createdAt)}
        />

      </ResponsiveTable>
    }
    </section>
  );
};

FraudCheckList.propTypes = {
  t: PropTypes.func.isRequired,
};

export default translate()(FraudCheckList);



// WEBPACK FOOTER //
// ./src/common/components/data-display/FraudCheckList.js